import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { AbiertaComponent } from './abierta/abierta.component';

import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import * as backInter from 'app/auth/auth-data.model';

import Swal from 'sweetalert2';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'preguntaAdicional',
  templateUrl: './pregunta.component.html',
  styleUrls: ['./pregunta.component.scss']
})
export class PreguntaComponent implements OnInit {

  @Input('idPreg') idPregunta: number;
  @Input('productoMedir') productoMedir: backInter.prodMed;
  @Input('idiomas') idiomas: backInter.getIdiomas;
  @Input('datosPregunta') datosPregunta?: backInter.getAdicional;
  @Input('iterPregunta') iterPregunta: number;
  @Input('pasoCompleto') pasoCompleto: boolean;

  @Output() idPreguntaBorrar: EventEmitter<number> = new EventEmitter();
  @Output() mensajeSnack: EventEmitter<any> = new EventEmitter();
  @Output() mensajeSwal: EventEmitter<any> = new EventEmitter();

  textoPregunta: string;
  seleccionado = false;
  tipoPregunta: number;

  idiomaDefault: backInter.getIdiomaInd;

  //ID de la pregunta almacenada en BD, se coloca al guardar la pregunta
  idPreguntaBD: string;
  idTraduccionBD: string;
  idsOpcionesBD: any[] = [];

  //etiquetas para encontrar los textos de traduccion
  mensajesTraducirKeys: string[] = [
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.BORRAR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.BOTONES.SI',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.BOTONES.NO',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_MOD_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_MOD_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_MOD_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_MOD_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_DEL_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_DEL_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_DEL_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_DEL_ERR',
    'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.RESTRICCION'
  ]
  //variables que tomaran las traducciones indicadas en la variable anterior
  //deben ir en el mismo orden
  mensajesTraducirTS = {
    borrar: '',
    si: '',
    no: '',
    preg_ok: '',
    preg_err: '',
    preg_mod_ok: '',
    preg_mod_err: '',
    opc_ok: '',
    opc_err: '',
    opc_mod_ok: '',
    opc_mod_err: '',
    preg_del_ok: '',
    preg_del_err: '',
    opc_del_ok: '',
    opc_del_err: '',
    restriccion: ''
  };

  constructor(
    private adicionalesService: AdicionalesService,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
  }

  ngOnInit() {
    this.obtieneIdiomaPrincipal();
    this.colocaDatosPreguntaExistente();
    this.traduceTextosTS();
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
  }

  colocaDatosPreguntaExistente(){
    // console.log("Datos de pregunta existente:");
    // console.log(this.datosPregunta);
    if(this.datosPregunta){
      this.datosPregunta.adicional.forEach( (elemento) => {
        if(elemento.idiomaAdicionales == this.idiomaDefault._id){
          // console.log("Se encontro el idioma principal");
          this.textoPregunta = elemento.textoPregunta;
          this.tipoPregunta = elemento.tipoPreguntaAdicionales;
          this.idPreguntaBD = this.datosPregunta._id;
          this.idTraduccionBD = elemento._id;
          this.seleccionado = true;

          if(elemento.opciones.length > 0){
            let iterador = 0;
            elemento.opciones.forEach( (opcion) => {
              // console.log(opcion);
              let datosOpcionAdicional: any = {idOpcionBD:opcion, idOpcionIter:iterador};
              this.idsOpcionesBD.push(datosOpcionAdicional);
              iterador++;
            });
            // this.ordenaOpcionesAlCargar(elemento.opciones);
          }
          // console.log(this.textoPregunta+" - "+this.tipoPregunta+" - "+this.idPreguntaBD+" - "+this.idTraduccionBD);
        }
      });
    }
  }

  ordenaOpcionesAlCargar(opciones:any){
    // let iter1 = 0;
    //
    // for(iter1=0;iter1<opciones.length;iter1++){
    //
    //   let idOpcionEncontrado:string;
    //   var BreakException = {};
    //   try {
    //       opciones.forEach( (opcion) => {
    //         if(opcion.ordenOpcion == iter1){
    //           let datosOpcionAdicional: any = {idOpcionBD:opcion, idOpcionIter:iter1};
    //           this.idsOpcionesBD.push(datosOpcionAdicional);
    //         }
    //       });
    //   } catch (e) {
    //       if (e !== BreakException) throw e;
    //   }
    // }
    let iter=0;
    opciones.forEach( (opcion) => {
      let datosOpcionAdicional: any = {idOpcionBD:opcion, idOpcionIter:iter};
      this.idsOpcionesBD.push(datosOpcionAdicional);
      this.actualizaOpcionBD(opcion._id,iter,null,''+iter+'');
      iter++;
    });
    console.log(this.idsOpcionesBD);
  }

  obtieneIdiomaPrincipal(){
    this.idiomas.idiomasMostrar.forEach( (idioma: backInter.getIdiomaInd) => {
      if(idioma.tipoIdioma == "1"){
        this.idiomaDefault = idioma;
      }
    });
  }


  setTextoPregunta(pregunta:string){
    this.textoPregunta = pregunta;
  }

  selTipoPregunta(tipoPregunta: number){
    this.seleccionado = true;
    this.tipoPregunta = tipoPregunta
  }

  enviarPreguntaBD(){
    if(this.textoPregunta && this.textoPregunta.length > 0){
      if(!this.idPreguntaBD && !this.idTraduccionBD)
      {
        let adicional = {} as backInter.nuevoAdicional;
        adicional.fechaMedir = this.productoMedir.fechaMedir;
        adicional.tipoPreguntaAdicionales = this.tipoPregunta;
        adicional.textoPregunta = this.textoPregunta;
        adicional.idiomaAdicionales = this.idiomaDefault._id;
        adicional.orden = this.iterPregunta;

        // console.log(adicional);
        this.adicionalesService.guardaAdicionalMedir(adicional).subscribe( (data: backInter.respuestaNuevoAdicional) => {
          if(data.message == "240"){
            this.idPreguntaBD = data.idAdicionalExterna;
            this.idTraduccionBD = data.idAdicionalInterna;
            this.enviaMensajeSnack(1);
          }
          else this.enviaMensajeSnack(2);
        });

      }
      else{
        let adicional = {} as backInter.modificaAdicional;
        adicional.fechaMedir = this.productoMedir.fechaMedir;
        adicional.arrayId = this.idPreguntaBD;
        adicional.adicionalId = this.idTraduccionBD;
        adicional.textoPregunta = this.textoPregunta;

        this.adicionalesService.actualizaAdicionalMedir(adicional).subscribe( (data: backInter.respuestaModifAdicional) => {
          if(data.message == "Success"){
            this.enviaMensajeSnack(3);
          }
          else this.enviaMensajeSnack(4);
          // console.log(data);
        });
      }
    }
  }

  guardarOpcionRespuestaBD(datosOpcion:any){
    if(this.idPreguntaBD && this.idTraduccionBD)
    {
      //comprueba en el arreglo de ids opciones si la opcion ya cuenta con id, compara sus id iterador
      if(this.idsOpcionesBD.length > 0)
      {
        let index = 0;
        let idOpcionEncontrado:string;
        var BreakException = {};
        try {
            this.idsOpcionesBD.forEach( (elemento) => {
              if(elemento.idOpcionIter == datosOpcion.idOpcion){
                idOpcionEncontrado = elemento.idOpcionBD._id;
                throw BreakException;
              }
              index++;
            });
        } catch (e) {
            if (e !== BreakException) throw e;
        }

        if(idOpcionEncontrado){
          //actualizar
          this.actualizaOpcionBD(idOpcionEncontrado, datosOpcion.orden, datosOpcion.textoOpcion, null);
        }
        else{
          //guardar nueva si no se encontro su id de bd
          this.guardaOpcionBD(datosOpcion);
        }

      }
      else{
        //guardar nueva opcion
        this.guardaOpcionBD(datosOpcion);
      }
    }
  }

  guardaOpcionBD(datosOpcion:any){
    let opcion = {} as backInter.nuevaOpcionAdicional;
    opcion.fechaMedir = this.productoMedir.fechaMedir;
    opcion.arrayId = this.idPreguntaBD;
    opcion.adicionalId = this.idTraduccionBD;
    opcion.textoOpcion = datosOpcion.textoOpcion;
    opcion.ordenOpcion = datosOpcion.orden;
    // console.log("Datos a enviar a bd:");
    // console.log(opcion);

    this.adicionalesService.guardaOpcionRespuestaAdicionalMedir(opcion)
    .subscribe( (data: backInter.respuestaNuevaOpcionAdicional) => {
      if(data.message == "Success"){
        //guarda la id de la opcion obtenida en el arreglo de ids opciones
        let objetoOpcionAdicional: backInter.opcionAdicional = { _id: data.opcionMostrar._id , textoOpcion: datosOpcion.textoOpcion };
        let idOpcionAdicional: any = {idOpcionBD:objetoOpcionAdicional, idOpcionIter:datosOpcion.idOpcion};
        this.idsOpcionesBD.push(idOpcionAdicional);
        this.enviaMensajeSnack(7);
        // console.log("se guardo la opcion");
      }
      else{
        this.enviaMensajeSnack(8);
        // console.log("no se guardo la opcion");
      }
    });
  }

  actualizaOpcionBD(idOpcionEncontrado:string, orden:number, textoOpcion?:string, ordenOpcion?:string){
    let opcion = {} as backInter.nuevaOpcionAdicional;
    opcion.fechaMedir = this.productoMedir.fechaMedir;
    opcion.arrayId = this.idPreguntaBD;
    opcion.adicionalId = this.idTraduccionBD;
    opcion.idOpcion = idOpcionEncontrado;
    if(textoOpcion)
      opcion.textoOpcion = textoOpcion;
    if(ordenOpcion)
      opcion.ordenOpcion = ordenOpcion;

    console.log("se actualizara una opcion. datos:");
    console.log(opcion);

    this.adicionalesService.actualizaOpcionRespuestaAdicionalMedir(opcion)
    .subscribe( (data: backInter.respuestaModificaOpcionAdicional) => {
      if(data.message == "Success"){
        if(textoOpcion){
          this.enviaMensajeSnack(9);
          console.log("se actualizo la opcion");
        }
      }
      else{
        if(textoOpcion)
          this.enviaMensajeSnack(10);
      }
    });
  }

  // EVENTOS DE EMISION DE DATOS A COMPONENTE SUPERIOR
  borrarPregunta(){
    if(!this.pasoCompleto){
      ///ventana modal de pregunta
      Swal.fire({
        /*title: 'Are you sure?',*/
        title: this.mensajesTraducirTS.borrar,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: this.mensajesTraducirTS.si,
        cancelButtonText: this.mensajesTraducirTS.no
      }).then((result) => {
        if (result.value) {
          if(this.idPreguntaBD && this.idTraduccionBD)
          {
            let adicional = {} as backInter.modificaAdicional;
            adicional.fechaMedir = this.productoMedir.fechaMedir;
            adicional.arrayId = this.idPreguntaBD;
            adicional.vivoAdicional = "0";

            // console.log("pregunta a borrar:");
            // console.log(adicional);

            this.adicionalesService.borraAdicionalMedir(adicional).subscribe( (data:backInter.respuestaModifAdicional) => {
              if(data.message == "Success"){
                this.idPreguntaBorrar.emit(this.idPregunta);
                this.enviaMensajeSwal(5);
                this.idPreguntaBD = null;
                this.idTraduccionBD = null;
              }
              else this.enviaMensajeSwal(6);
            });
          }
          else{
            this.idPreguntaBorrar.emit(this.idPregunta);
            this.enviaMensajeSwal(5);
          }
        }
      });
      // this.idPreguntaBorrar.emit(this.idPregunta);
    }
    else{
      this.enviaMensajeSwal(13);
    }
  }

  borrarOpcionBD(idOpcionIter:number){
    if(this.idsOpcionesBD.length > 0)
    {
      let index = 0;
      let idOpcionEncontrado:string;
      var BreakException = {};
      try {
          this.idsOpcionesBD.forEach( (elemento) => {
            if(elemento.idOpcionIter == idOpcionIter){
              idOpcionEncontrado = elemento.idOpcionBD._id;
              throw BreakException;
            }
            index++;
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      }

      if(idOpcionEncontrado){
        //eliminaOpcionRespuestaAdicional
        let opcion = {} as backInter.nuevaOpcionAdicional;
        opcion.fechaMedir = this.productoMedir.fechaMedir;
        opcion.arrayId = this.idPreguntaBD;
        opcion.adicionalId = this.idTraduccionBD;
        opcion.idOpcion = idOpcionEncontrado;
        opcion.vivoOpcion = "0";

        this.adicionalesService.eliminaOpcionRespuestaAdicionalMedir(opcion)
        .subscribe( (data: backInter.respuestaModificaOpcionAdicional) => {
          if(data.message == "Success"){
            this.idsOpcionesBD.splice(index,1);
            this.enviaMensajeSwal(11);
          }
          else this.enviaMensajeSwal(12);
        });
      }
      else{
        //guardar nueva si no se encontro su id de bd
      }

    }
  }
  //mensajes snack bar para guardados automaticos
  enviaMensajeSnack(resultado:number){
    let datosSnack: any;
    switch(resultado){
      case 1: datosSnack = {mensaje:this.mensajesTraducirTS.preg_ok, accion:"OK"}; break;
      case 2: datosSnack = {mensaje:this.mensajesTraducirTS.preg_err, accion:"OK"}; break;
      case 3: datosSnack = {mensaje:this.mensajesTraducirTS.preg_mod_ok, accion:"OK"}; break;
      case 4: datosSnack = {mensaje:this.mensajesTraducirTS.preg_mod_err, accion:"OK"}; break;
      case 7: datosSnack = {mensaje:this.mensajesTraducirTS.opc_ok, accion:"OK"}; break;
      case 8: datosSnack = {mensaje:this.mensajesTraducirTS.opc_err, accion:"OK"}; break;
      case 9: datosSnack = {mensaje:this.mensajesTraducirTS.opc_mod_ok, accion:"OK"}; break;
      case 10: datosSnack = {mensaje:this.mensajesTraducirTS.opc_mod_err, accion:"OK"}; break;
    }
    this.mensajeSnack.emit(datosSnack);
  }

  //mensajes swal para confirmaciones de eliminacion
  enviaMensajeSwal(resultado:number){
    let datosSwal: any;
    switch(resultado){
      case 5: datosSwal = {mensaje:this.mensajesTraducirTS.preg_del_ok, tipo:"success"}; break;
      case 6: datosSwal = {mensaje:this.mensajesTraducirTS.preg_del_err, tipo:"error"}; break;
      case 11: datosSwal = {mensaje:this.mensajesTraducirTS.opc_del_ok, tipo:"success"}; break;
      case 12: datosSwal = {mensaje:this.mensajesTraducirTS.opc_del_err, tipo:"error"}; break;
      case 13: datosSwal = {mensaje:this.mensajesTraducirTS.restriccion, tipo:"warning"}; break;
    }
    this.mensajeSwal.emit(datosSwal);
  }
}
